import { useModalContext } from '@/contexts/ModalContext';

type MobileAuthButtonsProps = {
  onClose: () => void;
};

export default function MobileAuthButtons({ onClose }: MobileAuthButtonsProps) {
  const { openLoginModal, openSignupModal } = useModalContext();

  const handleLogin = () => {
    openLoginModal();
    onClose();
  };

  const handleSignup = () => {
    openSignupModal();
    onClose();
  };

  return (
    <div className="space-y-3">
      <button
        className={
          'w-full rounded-lg border border-gray-200 bg-white py-3 text-center text-sm font-medium text-gray-700 hover:bg-gray-50'
        }
        onClick={handleLogin}
      >
        Login
      </button>
      <button
        className={
          'w-full rounded-lg py-3 text-center text-sm font-medium text-white bg-[linear-gradient(128deg,#113D7B_0%,#0E4EA8_100%)] hover:brightness-[0.88] hover:shadow-sm'
        }
        onClick={handleSignup}
      >
        Join Equipool
      </button>
    </div>
  );
}
